import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { DEFAULT_REPORT_TIMEZONE } from 'dashboard/helper/reportPeriod';

/**
 * Fuso em que os relatorios de atendimento fecham o dia. Vem da conta, nunca do
 * navegador. Tambem diz se ele difere do fuso deste computador, para a tela
 * poder avisar antes de alguem estranhar a borda do dia.
 */
export function useReportTimezone() {
  const { currentAccount } = useAccount();

  const reportTimezone = computed(
    () => currentAccount.value?.reporting_timezone || DEFAULT_REPORT_TIMEZONE
  );

  const browserTimezone = computed(() => {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    } catch (error) {
      return '';
    }
  });

  const differsFromBrowser = computed(
    () =>
      !!browserTimezone.value && browserTimezone.value !== reportTimezone.value
  );

  return { reportTimezone, browserTimezone, differsFromBrowser };
}
